// tslint:disable-next-line:object-literal-sort-keys
import React, {useEffect, useState} from 'react';
import {compose} from 'redux';
import {get, put} from '../../../api/api';
import * as fonts from '../../../util/fonts';
import {Column, Row} from '../../../components/layout';
import {connect} from 'react-redux';
import BannerModalComponent from './components/BannerModalComponent';

import './styles.scss';
import {Carousel} from 'react-bootstrap';
import AppButton from '../../../components/app-button';
import ModalTemplate from '../../../components/modal';
import colors from '../../../util/colors';
import {
  uriBannerLoginState,
  uriUpdateBannerLoginState,
} from '../../../api/endpoints';
import {useMediaQuery} from 'react-responsive';
import moment from 'moment';
import AuthorizedImage from '../../../components/images';
export interface BannerProps {
  buStyles: any;
  selectedBu: any;
  user: any;
  campaigns: any;
  enableBanner: any;
}

function Banner({
  selectedBu,
  buStyles,
  user,
  campaigns,
  enableBanner,
}: BannerProps) {
  const [banners, setBanners]: any = useState([]);
  const [showClickedBanner, setShowClickedBanner] = useState(false);
  const [currentBanner, setCurrentBanner]: any = useState();
  const [showModalOnLogin, setShowModalOnLogin] = useState(false);
  const [visibleBanner, setVisibleBanner]: any = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [singleBanner, setSingleBanner] = useState(false);

  const featureName = 'BannersHomepage';

  const isResponsive = useMediaQuery({maxDeviceWidth: 768});
  const urlPrefix = process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL; //prefix for images

  //calls api to check which banner modal should appear in login
  const verifyBanner = async (visibleBanners: any) => {
    try {
      visibleBanners.map(async (a: any) => {
        const result = await get(
          uriBannerLoginState(
            a.campaignAlias,
            a.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.listAppHasLink,
            user.sub
          ),
          false,
          0,
          featureName
        );
        if (result) {
          setVisibleBanner(a);
          setShowModalOnLogin(true);
          return;
        }
      });
    } catch {}
  };

  useEffect(() => {
    setIsLoading(true);
    let currentDate = moment();
    if (campaigns?.length > 0) {
      const activeBanners: any = [];
      const visibleBanners: any = [];
      campaigns
        .filter((campaign: any) => campaign.status === 'ACTIVE')
        .forEach((campaign: any) => {
          const isInactive = campaign.campaignInactiveBUS.some(
            (buAlias: string) => buAlias === selectedBu.buId
          );
          if (
            !isInactive &&
            moment(campaign.startDate, 'DD-MM-YYYY').isSameOrBefore(
              currentDate,
              'day'
            ) &&
            moment(campaign.endDate, 'DD-MM-YYYY').isSameOrAfter(
              currentDate,
              'day'
            )
          ) {
            activeBanners.push(campaign);
            if (campaign.visibleLogin) {
              visibleBanners.push(campaign);
            }
          }
        });
      setBanners(activeBanners);

      activeBanners.length === 1
        ? setSingleBanner(true)
        : setSingleBanner(false);

      visibleBanners.sort((a: any, b: any) => {
        if (a.endDate > b.endDate) {
          return 1;
        }
        if (a.endDate < b.endDate) {
          return -1;
        }
        return 0;
      });

      if (localStorage.getItem('show_login_modal') === 'true') {
        verifyBanner(visibleBanners);
      }
    }

    setIsLoading(false);
  }, [selectedBu.memId, campaigns]);

  const handleBannerClick = (item: any) => {
    setCurrentBanner(item);
    setShowClickedBanner(true);
  };

  //Render every carousel item
  const renderCarouselItem = () =>
    banners.map((item: any) => {
      return (
        <Carousel.Item>
          <AuthorizedImage
            source={`${urlPrefix}${
              item.campaignDetails.find(
                (detail: any) => detail.languageAlias === user.language
              )?.bannerImageBackground
            }`}
            className="banner-img"
          />
          <Carousel.Caption>
            <Row className="banner-content-row">
              {!isResponsive && (
                <Column className="banner-content-column-left">
                  {item.campaignDetails.find(
                    (detail: any) => detail.languageAlias === user.language
                  )?.bannerImageLittle && (
                    <AuthorizedImage
                      source={`${urlPrefix}${
                        item.campaignDetails.find(
                          (detail: any) =>
                            detail.languageAlias === user.language
                        )?.bannerImageLittle
                      }`}
                      className="image-little"
                    />
                  )}
                </Column>
              )}
              <Column
                className={
                  !item.campaignDetails.find(
                    (detail: any) => detail.languageAlias === user.language
                  )?.bannerDescription
                    ? 'banner-content-column-right-no-desc'
                    : 'banner-content-column-right'
                }>
                <Row className="banner-title-row">
                  <p
                    className="banner-title"
                    style={{
                      ...fonts.XL,
                      color: item.campaignDetails.find(
                        (detail: any) => detail.languageAlias === user.language
                      )?.bannerTextColor,
                    }}>
                    {
                      item.campaignDetails.find(
                        (detail: any) => detail.languageAlias === user.language
                      )?.bannerTitle
                    }
                  </p>
                </Row>
                <Row className="banner-description-row">
                  <p
                    className="banner-description"
                    style={
                      isResponsive
                        ? {
                            ...fonts.M,
                            color: item.campaignDetails.find(
                              (detail: any) =>
                                detail.languageAlias === user.language
                            )?.bannerTextColor,
                          }
                        : {
                            ...fonts.MM,
                            color: item.campaignDetails.find(
                              (detail: any) =>
                                detail.languageAlias === user.language
                            )?.bannerTextColor,
                          }
                    }>
                    {' '}
                    {
                      item.campaignDetails.find(
                        (detail: any) => detail.languageAlias === user.language
                      )?.bannerDescription
                    }
                  </p>
                </Row>
                {item.campaignDetails.find(
                  (detail: any) => detail.languageAlias === user.language
                )?.bannerButtonVisible && (
                  <AppButton
                    onClick={() => handleBannerClick(item)}
                    className="banner-button"
                    variant={'primary'}
                    style={{
                      backgroundColor: item.campaignDetails.find(
                        (detail: any) => detail.languageAlias === user.language
                      )?.bannerButtonTransparent
                        ? 'rgba(250,250,250,0)'
                        : item.campaignDetails.find(
                            (detail: any) =>
                              detail.languageAlias === user.language
                          )?.bannerButtonColor,
                      border: item.campaignDetails.find(
                        (detail: any) => detail.languageAlias === user.language
                      )?.bannerButtonTransparent
                        ? `2px solid white`
                        : '',
                    }}>
                    {
                      item.campaignDetails.find(
                        (detail: any) => detail.languageAlias === user.language
                      )?.bannerButtonText
                    }
                  </AppButton>
                )}
              </Column>
            </Row>
          </Carousel.Caption>
        </Carousel.Item>
      );
    });

  const handleModalSubmit = async (action: any) => {
    const body = {
      bannerAlias: currentBanner
        ? currentBanner?.campaignAlias
        : visibleBanner?.campaignAlias,
      hasClick: currentBanner
        ? currentBanner?.campaignDetails.find(
            (detail: any) => detail.languageAlias === user.language
          )?.modalButtonVisible
        : visibleBanner?.campaignDetails.find(
            (detail: any) => detail.languageAlias === user.language
          )?.modalButtonVisible,
      action: action,
    };

    try {
      await put(uriUpdateBannerLoginState(), body, featureName);
    } finally {
      localStorage.setItem('show_login_modal', 'false');
    }

    setShowClickedBanner(false);
    setShowModalOnLogin(false);
  };

  const renderAppLink = (href: any, isLogin: any) => {
    const bannerToUse = isLogin ? visibleBanner : currentBanner;

    return (
      <>
        <a
          style={{
            backgroundColor: bannerToUse?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalButtonColor,
          }}
          href={
            href === 'e-mail'
              ? `mailto:${
                  bannerToUse?.campaignDetails.find(
                    (detail: any) => detail.languageAlias === user.language
                  )?.modalButtonUrl
                }`
              : href === 'telefone'
              ? `tel:${
                  bannerToUse?.campaignDetails.find(
                    (detail: any) => detail.languageAlias === user.language
                  )?.modalButtonUrl
                }`
              : ''
          }>
          <AppButton
            className={'service-details-button'}
            onClick={() => handleModalSubmit('CLICK')}>
            {
              bannerToUse?.campaignDetails.find(
                (detail: any) => detail.languageAlias === user.language
              )?.modalButtonText
            }
          </AppButton>
        </a>
      </>
    );
  };

  //render different types of buttons in the modal
  const renderModalButton = (type: any, isLogin: any) => {
    const bannerToUse = isLogin ? visibleBanner : currentBanner;

    if (type === 'link') {
      return (
        <AppButton
          className={'banner-modal-button'}
          onClick={() => {
            window.open(
              bannerToUse?.campaignDetails.find(
                (detail: any) => detail.languageAlias === user.language
              )?.modalButtonUrl,
              '_blank'
            );
            handleModalSubmit('CLICK');
          }}
          style={{
            backgroundColor: bannerToUse?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalButtonColor,
          }}>
          {
            bannerToUse?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalButtonText
          }
        </AppButton>
      );
    } else {
      return renderAppLink(type, isLogin);
    }
  };

  const renderDefaultPrevIcon = () => {
    return <span aria-hidden="true" className="carousel-control-prev-icon" />;
  };

  const renderDefaultNextIcon = () => {
    return <span aria-hidden="true" className="carousel-control-next-icon" />;
  };

  //render modals
  const renderModal = (isLogin: any) => {
    return (
      <>
        <Row className="banner-modal-title-row">
          <p
            style={{...fonts.XL, color: colors.black}}
            className="banner-modal-title">
            {isLogin
              ? visibleBanner?.campaignDetails.find(
                  (detail: any) => detail.languageAlias === user.language
                )?.modalTitle
              : currentBanner?.campaignDetails.find(
                  (detail: any) => detail.languageAlias === user.language
                )?.modalTitle}
          </p>
        </Row>
        <Row className="banner-modal-img-row">
          <div className="health-data-popup-icon-container">
            <AuthorizedImage
              source={
                isLogin
                  ? `${urlPrefix}${
                      visibleBanner?.campaignDetails.find(
                        (detail: any) => detail.languageAlias === user.language
                      )?.modalImage
                    }`
                  : `${urlPrefix}${
                      currentBanner?.campaignDetails.find(
                        (detail: any) => detail.languageAlias === user.language
                      )?.modalImage
                    }`
              }
              className="modal-img"
              width="237"
              height="203"
            />
          </div>
        </Row>
        <BannerModalComponent
          style={{...fonts.MM, ...fonts.Medium}}
          className="banner-modal-description-bold"
          isLogin={isLogin}
          visibleBannerString={
            visibleBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalDescription
          }
          currentBannerString={
            currentBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalDescription
          }
        />
        <BannerModalComponent
          style={{...fonts.MM, ...fonts.Regular}}
          className="banner-modal-description-bold"
          isLogin={isLogin}
          visibleBannerString={
            visibleBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalSubtitle1
          }
          currentBannerString={
            currentBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalSubtitle1
          }
        />
        <BannerModalComponent
          style={{...fonts.MM, ...fonts.Light}}
          className="banner-modal-description-bold"
          isLogin={isLogin}
          visibleBannerString={
            visibleBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalText1
          }
          currentBannerString={
            currentBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalText1
          }
        />
        <BannerModalComponent
          style={{...fonts.MM, ...fonts.Regular}}
          className="banner-modal-description-bold"
          isLogin={isLogin}
          visibleBannerString={
            visibleBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalSubtitle2
          }
          currentBannerString={
            currentBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalSubtitle2
          }
        />
        <BannerModalComponent
          style={{...fonts.MM, ...fonts.Light}}
          className="banner-modal-description-bold"
          isLogin={isLogin}
          visibleBannerString={
            visibleBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalText2
          }
          currentBannerString={
            currentBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalText2
          }
        />
        {(isLogin
          ? visibleBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalButtonVisible
          : currentBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalButtonVisible) && (
          <Row className="banner-modal-row">
            {renderModalButton(
              isLogin
                ? visibleBanner?.campaignDetails.find(
                    (detail: any) => detail.languageAlias === user.language
                  )?.modalButtonType
                : currentBanner?.campaignDetails.find(
                    (detail: any) => detail.languageAlias === user.language
                  )?.modalButtonType,
              isLogin
            )}
          </Row>
        )}
        <BannerModalComponent
          style={{...fonts.MM, ...fonts.Light}}
          className="banner-modal-description-bold"
          rowClassName="banner-modal-footer"
          isLogin={isLogin}
          visibleBannerString={
            visibleBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalFooter
          }
          currentBannerString={
            currentBanner?.campaignDetails.find(
              (detail: any) => detail.languageAlias === user.language
            )?.modalFooter
          }
        />
      </>
    );
  };

  return (
    <>
      {!isLoading && enableBanner && (
        <Row>
          <div className="banner-container">
            <Carousel
              fade
              prevIcon={singleBanner ? <></> : renderDefaultPrevIcon()}
              nextIcon={singleBanner ? <></> : renderDefaultNextIcon()}
              className="carousel-banners">
              {renderCarouselItem()}
            </Carousel>
          </div>
        </Row>
      )}
      <ModalTemplate
        show={showClickedBanner}
        className="banner-modal"
        size="xl"
        onHide={() => setShowClickedBanner(false)}
        hideFooter={true}
        cross={true}>
        {showClickedBanner && renderModal(false)}
      </ModalTemplate>
      <ModalTemplate
        show={showModalOnLogin}
        className="banner-modal"
        size="xl"
        onHide={() => {
          setShowModalOnLogin(false);
          handleModalSubmit('CLOSE');
        }}
        hideFooter={true}
        cross={true}>
        {showModalOnLogin && renderModal(true)}
      </ModalTemplate>
    </>
  );
}

const mapStateToProps = ({selectedBu, globalStyles, user}: any) => ({
  selectedBu: selectedBu.value,
  buStyles: globalStyles.value,
  user: user.value,
});

export default compose(connect(mapStateToProps)(Banner));
